import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { formatDate } from "src/Common/common";
import { can } from "src/Common/function";
import ServiceTypeService from "src/Services/API/service.service";

const Archive = () => {
  const canRestore = can("service:restore");
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [restoringId, setRestoringId] = useState(null);

  useEffect(() => {
    getArchivedServices();
  }, []);

  const getArchivedServices = async () => {
    setIsLoading(true);
    try {
      const response = await ServiceTypeService.getAll();
      if (response.status === 200) {
        const data = Array.isArray(response.data) ? response.data : [];
        const archivedServices = data.filter((service) => service?.isActive === false || service?.isArchived === true);
        setServices(archivedServices);
      } else {
        toast("Something went wrong");
      }
    } catch (error) {
      console.log("Service type load error: ", error);
      toast(error?.response?.data?.message || "Failed to load archived services");
    } finally {
      setIsLoading(false);
    }
  };

  const handleRestore = async (service) => {
    if (!service?.id) return;
    setRestoringId(service.id);
    try {
      const response = await ServiceTypeService.restore(service.id);
      if (response.status === 200 || response.status === 201) {
        toast("Service restored successfully");
        getArchivedServices();
      } else {
        toast("Something went wrong");
      }
    } catch (error) {
      console.log("Service type restore error: ", error);
      toast(error?.response?.data?.message || "Failed to restore service");
    } finally {
      setRestoringId(null);
    }
  };

  return (
    <div className="mt-4">
      {isLoading && <p className="text-[12px] font-OpenSansRegular text-subTitleColor">Loading archived services...</p>}
      {!isLoading && services.length === 0 && (
        <p className="text-[12px] font-OpenSansRegular text-subTitleColor">No archived services.</p>
      )}
      {!isLoading && services.length > 0 && (
        <div
          className="w-full flex flex-col overflow-hidden max-h-[calc(100vh-220px)]"
          style={{
            borderRadius: "12px",
            border: "1px solid #E5E8F3",
            background: "#FFF",
            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.00), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
          }}
        >
          <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
          <table className="w-full table-fixed">
            <thead className="sticky top-0 z-10">
              <tr
                style={{ borderBottom: "1px solid #E5E8F3", background: "#F8F9FE" }}
                className="[&>th]:border-r [&>th]:border-borderColor [&>th:last-child]:border-r-0"
              >
                <th>
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center px-4 h-[44px] text-[#5F6477]">
                    <span>Name</span>
                  </div>
                </th>
                {/* <th className="w-[180px]">
                  <div className="font-OpenSansRegular font-[600] text-[12px] leading-[18px] flex items-center px-4 h-[44px] text-[#5F6477]">
                    Archived On
                  </div>
                </th> */}
                <th className="w-[120px]"></th>
              </tr>
            </thead>
            <tbody>
              {services.map((service) => (
                <tr
                  key={service.id || service.name}
                  className="border-b border-borderColor hover:bg-[#FAFAFB] [&>td]:border-r [&>td]:border-borderColor [&>td:last-child]:border-r-0"
                >
                  <td>
                    <div className="font-OpenSansRegular px-4 py-3 text-[13px] font-[400] leading-[20px] text-[#1A2332]">
                      {service.serviceType}
                    </div>
                  </td>
                  {/* <td>
                    <div className="font-OpenSansRegular px-4 py-3 text-[13px] font-[400] leading-[20px] text-[#1A2332]">
                      {service.archivedAt || service.updatedAt || service.createdAt
                        ? formatDate(service.archivedAt || service.updatedAt || service.createdAt)
                        : "-"}
                    </div>
                  </td> */}
                  <td>
                    <div className="px-4 py-3">
                      {canRestore && (
                        <button
                          type="button"
                          disabled={restoringId === service.id}
                          onClick={() => handleRestore(service)}
                          className="rounded-[6px] bg-blueColor px-3 py-1 text-[11px] font-OpenSansMedium text-white disabled:opacity-60"
                        >
                          {restoringId === service.id ? "Restoring..." : "Restore"}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Archive;
